<template>
  <div class="fileCardWrapper">
    <div class="cardLeft">
      <div class="mask" v-if="showMask">
        <span class="title">AI处理中...</span>
        <div>请耐心等待~</div>
        <div>请不要关闭浏览器！</div>
      </div>
      <img :src="fileInfo.origin?.src || defaultIcon" alt="" class="cardImg" />
      <div class="fileName">
        {{ fileInfo.origin?.filename }}
      </div>
    </div>
    <div class="cardRight">
      <div v-if="!isLoading" class="fileInfo">
        <div class="cardCorner" @click="handleRemove">
          <span class="icon"></span>
        </div>
        <div class="infoBox">
          <p class="txt">原图</p>
          <p class="info">
            <span>{{ fileInfo.origin?.suffix }}</span>

            <span
              >{{ fileInfo.origin?.width }}x{{ fileInfo.origin?.height }}</span
            >
            <span>{{ fileInfo.origin?.size }}kb</span>
          </p>
        </div>

<!--        <div-->
<!--          class="resultBox"-->
<!--          v-if="handlingMethod === 'losslessAmplification'"-->
<!--        >-->
<!--          <div class="infoBox">-->
<!--            <p class="txt">放大后</p>-->
<!--            <p class="info">-->
<!--              <span>{{ fileInfo.target?.suffix }}</span>-->
<!--              <span>{{ showWH }}</span>-->
<!--              <span>{{ fileInfo.target?.size }}kb</span>-->
<!--            </p>-->
<!--          </div>-->
<!--          <div class="btnGroups">-->
<!--            <button class="btn" @click="handlePreview">预览</button>-->
<!--            <button class="btn" @click="downloadImage">下载</button>-->
<!--          </div>-->
<!--        </div>-->
<!--        <div-->
<!--          class="resultBox"-->
<!--          v-else-if="handlingMethod === 'clearnessAamplification'"-->
<!--        >-->
<!--          <div class="infoBox">-->
<!--            <p class="txt">增强后</p>-->
<!--            <p class="info">-->
<!--              <span>{{ fileInfo.target?.suffix }}</span>-->
<!--              <span>{{ showTxt }}</span>-->
<!--              <span>{{ fileInfo.target?.size }}kb</span>-->
<!--            </p>-->
<!--          </div>-->
<!--          <div class="btnGroups">-->
<!--            <button class="btn" @click="handlePreview">预览</button>-->
<!--            <button class="btn" @click="downloadImage">下载</button>-->
<!--          </div>-->
<!--        </div>-->
        <div
          class="resultBox"
          v-if="fileInfo.target?.raw"
        >
          <div class="infoBox">
            <p class="txt">{{ showText }}</p>
            <p class="info">
              <span>{{ fileInfo.target?.suffix }}</span>
              <span>{{ showTxt }}</span>
              <span>{{ fileInfo.target?.size }}kb</span>
            </p>
          </div>
          <div class="btnGroups">
            <button class="btn" @click="handlePreview">预览</button>
            <button class="btn" @click="downloadImage">下载</button>
          </div>
        </div>
      </div>
      <div v-else class="progressWrapper">
        <div class="progressBox">
          <div class="progress"></div>
        </div>
        <p>处理中...</p>
      </div>
    </div>
  </div>
</template>
<script>
import getImageFileInfo from '@/utils/getImageFileInfo'
import { changeImgDpi, editImage, increasePictureMemory, outputTheSpecifiedSize } from "@/core";
import { mapActions, mapGetters } from "vuex";
import { Message } from 'element-ui'
import { imageEnhance, photoRestoration, photoRestoration2, pictureDiscoloration } from "@/api";
import { uploadOSS } from "@/utils/uploadOSS";
import { v4 as uuidV4 } from "uuid";
import { BUCKET } from "@/store/amplification.store";
import request from "@/utils/request";
import { getToken } from "@/utils/token";

export default {
  name: 'FileCard3',
  components: {},
  props: {
    molti: {
      type: String,
      default: '0'
    },

    file: {
      validator: function (value) {
        return value.raw instanceof Blob
      }
    }
  },
  data() {
    return {
      isLoading: false,
      defaultIcon: require('@/assets/img/default_icon.svg'),
      fileInfo: {
        origin: {
          src: require('@/assets/img/default_icon.svg') // 给一张默认图
        },
        isDownload: false, // 是否下载过
        target: {}
      },
      handlingMethod: '' //表示我触发的那个窗口
    }
  },

  watch: {
    file: {
      async handler(val) {
        this.fileInfo.origin = await getImageFileInfo(val.raw)
      },
      immediate: true,
      deep: true
    }
  },
  computed: {
    ...mapGetters(['isVip', 'isLogin', 'getAllCert']),
    allCert() {
      return this.getAllCert
    },
    isUserLogin() {
      return this.isLogin
    },
    userIsVip() {
      return this.isVip
    },
    showWH() {
      const { width, height } = this.fileInfo.target
      return `${width * this.molti}x${height * this.molti}`
    },
    showTxt() {
      const { handlingMethod, dpi } = this.file.options
      const { width, height } = this.fileInfo.target
      return handlingMethod === 'changeDpi' ? `${dpi}dpi` : `${width}x${height}`
    },
    showText() {
      const { handlingMethod } = this.file.options
      let txt = '修改后'
      switch(handlingMethod) {
        case 'increaseMemory':
          txt = '处理后'
          break
        case 'laozhaopian':
          txt = '修复后'
          break
        case 'upcolor':
          txt = '上色后'
          break
        default:
          txt = '修改后'
          break
      }
      return txt
    },
    showMask() {
      let showArr = ['losslessAmplification', 'laozhaopian','upcolor', 'clearnessAamplification']
      return showArr.includes(this.file.options?.handlingMethod) && this.isLoading
    }
  },
  methods: {
    ...mapActions(['showLoginModal', 'showPurchaseModal', "updateUserInfo", 'setAllowDownload']),
    handleRemove() {
      this.$emit('remove', this.fileInfo)
    },
    handlePreview() {

      this.$emit('onPreview', this.fileInfo)
    },
    downloadImage() {
        this.$emit('download', this.fileInfo, this.file?.options)
    },
    updateDownloadStatus() {
      this.fileInfo.isDownload = false
    },
    // 无损放大 & 图片变清晰
    async losslessAmplification(file, molti, filename) {
      let uploadResult = await uploadOSS(
              `${uuidV4()}_${new Date().getTime()}_${Math.floor(Math.random() * 1000)}_${filename || file.name || 'unknown'}`,
              file,
              BUCKET
      )
      return await imageEnhance(uploadResult.url, Number(molti)) // 图片增强，获取到那个2 4 6 8的倍数值

    },
    /**
     * 老照片修复
     * @param modelType 模型类型 1: 模型一，2:模型二
     * @param file 待处理文件
     * @param type 处理类型
     * @param molti 推荐尺寸：0 推荐尺寸 1: 原尺寸
     * @param filename 文件名
     * @returns {Promise<AxiosResponse<*>>}
     */
    async photoFix(modelType, file, type, molti, filename) {
      let {url} = await uploadOSS(
              `${uuidV4()}_${new Date().getTime()}_${Math.floor(Math.random() * 1000)}_${filename || file.name || 'unknown'}`,
              file,
              BUCKET
      )

      if (modelType === 1) {
        return await photoRestoration2(url, type)
      }
      return await photoRestoration(url, type,molti)

    },
    // 黑白照上色
    async colorShifting(file, format, filename) {
      let {url} = await uploadOSS(
              `${uuidV4()}_${new Date().getTime()}_${Math.floor(Math.random() * 1000)}_${filename || file.name || 'unknown'}`,
              file,
              BUCKET
      )
      return await pictureDiscoloration(url, format)
    },
    async executeCompress(fileParams) {
      this.isLoading = true
      let { resize, width, height, scale, handlingMethod, dpi, size, molti, fix_mode, modelType, colorType, outputSize, colorShiftingOutputFormat} =
        fileParams.options
      // 放大图片的标识
      this.handlingMethod = handlingMethod
      this.file.options = fileParams.options
      let file = this.file.raw
      let originInfo = await getImageFileInfo(file)
      this.fileInfo.origin = originInfo
      this.fileInfo.status = 'pending'
      try {
        if (handlingMethod === 'edit') {
          let options = {}
          if (resize === 'cover') {
            // 当用户选择缩放，如果是缩放是1直接返回原图
            if (scale === 100) {
              this.fileInfo.target = originInfo
              this.fileInfo.status = 'success'
              return
            }

            width = originInfo.width * (scale / 100)
            options = {
              resize: 'cover',
              width
            }
          } else {
            if (width > 0 && height > 0) {
              if (width === originInfo.width && height === originInfo.height) {
                this.fileInfo.target = originInfo
                return
              }
              options = {
                resize: 'contain',
                width,
                height
              }
            } else if (width > 0 && height <= 0) {
              if (width === originInfo.width) {
                this.fileInfo.target = originInfo
                return
              }
              options = {
                resize: 'cover',
                width
              }
            } else if (height > 0 && width <= 0) {
              if (height === originInfo.height) {
                this.fileInfo.target = originInfo
                this.fileInfo.status = 'success'
                return
              }
              options = {
                resize: 'cover',
                height
              }
            } else {
              this.fileInfo.target = originInfo
              this.fileInfo.status = 'success'
              return
            }
          }

          let editImgBlob = await editImage(file, {
            ...options
          })
          this.fileInfo.target = await getImageFileInfo(editImgBlob)
        } else if (handlingMethod === 'changeDpi') {
          let dpiBlob = await changeImgDpi(file, { dpi })
          this.fileInfo.target = await getImageFileInfo(dpiBlob)
          this.fileInfo.target['filename'] = this.fileInfo.origin.filename
        } else if (handlingMethod === 'increaseMemory') {
          let blob = await increasePictureMemory(file, size * 1024)
          this.fileInfo.target = await getImageFileInfo(blob)
        } else if (
          handlingMethod === 'losslessAmplification' ||
          handlingMethod === 'clearnessAamplification'
        ) {

          if (!getToken()) {
            await this.showLoginModal()
            return
          }
          // if (!this.isVip && this.allCert?.image_enhance_init_count <= 0) {
          //   this.$messageDialog({
          //     showLeft: false,
          //     showRight: true,
          //     leftBtnTxt: '取消',
          //     rightBtnTxt: '开通VIP',
          //     title: '温馨提示',
          //     content: `试用次数已用完，请开通VIP后使用！`,
          //     onClose: () => {},
          //     onClickLeftBtn: () => {},
          //     onClickRightBtn: () => {
          //       this.showPurchaseModal()
          //     }
          //   })
          //   return
          // }

          let file1 = file

          if(originInfo?.width < 50 || originInfo?.height < 50) {
            Message.error('图片尺寸不得小于50px！')
            return
          }

          if (originInfo?.width > 2000 || originInfo?.height > 2000) {
            let options = {
              resize: 'cover'
            }

            if (originInfo?.width <= originInfo?.height) {
              options.height = 2000
            } else {
              options.width = 2000
            }

            file1 =  await editImage(file, {
              ...options
            })
          }
          let res = await this.losslessAmplification(file1, molti)
          if (res.data.status === 0) {
            const imageUrl = res.data?.data?.imageurl

            // let blob = await fetch(imageUrl).then(response => response.blob())
            // let blob = await this.delayFn(imageUrl).then(resp => resp.blob())

            let blob = await request(imageUrl, 200).then(response => response.blob())

            this.fileInfo.target = await getImageFileInfo(blob)
            const dl_token = res.data?.data?.userinfo?.dl_token
            this.fileInfo.target.dl_token = dl_token

              // TODO 更新用户权益
              /**
               * 获取到的用户信息
               */
              await this.updateUserInfo()
              this.setAllowDownload(Number(res.data?.data?.i) || 0)
            // }
          } else if (res.data.status === 5001) {
            this.fileInfo.status = 'fail'
            this.$messageDialog({
              showLeft: false,
              showRight: true,
              leftBtnTxt: '取消',
              rightBtnTxt: '开通VIP',
              title: '温馨提示',
              content: `试用次数已用完，请开通VIP后使用！`,
              onClose: () => {},
              onClickLeftBtn: () => {},
              onClickRightBtn: () => {
                this.showPurchaseModal()
              }
            })
          } else {
            this.fileInfo.status = 'fail'
            Message({
              type: 'error',
              message: '处理失败！'
            })
          }


        } else if (handlingMethod === 'laozhaopian') {
          if (!getToken()) {
            await this.showLoginModal()
            return
          }
          // if (!this.isVip && this.allCert?.image_enhance_init_count <= 0) {
          //   this.$messageDialog({
          //     showLeft: false,
          //     showRight: true,
          //     leftBtnTxt: '取消',
          //     rightBtnTxt: '开通VIP',
          //     title: '温馨提示',
          //     content: `试用次数已用完，请开通VIP后使用！`,
          //     onClose: () => {},
          //     onClickLeftBtn: () => {},
          //     onClickRightBtn: () => {
          //       this.showPurchaseModal()
          //     }
          //   })
          //   return
          // }

          let file1 = file
          let maxSize = 0
          let maxWidth = 0
          let maxHeight = 0

          if (modelType === 1) {
            maxWidth  = 2000
            maxHeight = 2000
            maxSize = 5 * 1024 * 1024
          } else if (modelType === 2) {
            maxWidth  = 4096
            maxHeight = 4096
            maxSize = 15 * 1024 * 1024
          }
          // 图片宽高不能超过 4096 * 4096
          if (originInfo?.width > maxWidth || originInfo?.height > maxHeight) {
            let options = {
              resize: 'cover'
            }

            if (originInfo?.width <= originInfo?.height) {
              options.height = maxHeight
            } else {
              options.width = maxWidth
            }

            file1 =  await editImage(file, {
              ...options
            })
          }

          // 超过15MB图片要压缩
          if (file1.size >= maxSize) {
            // 用户指定压缩大小
            file1 = await outputTheSpecifiedSize(file1, {
              maxSize: maxSize
            })
          }

          let res = null
          if (modelType === 1) {
            res = await this.photoFix(modelType, file1, colorType)
          } else if (modelType === 2) {
            res = await this.photoFix(modelType, file1, fix_mode, outputSize)
          }

          if (res.data.status === 0) {
            const imageUrl = res.data?.data?.imageurl


            let blob = await fetch(imageUrl).then(response => response.blob())

            this.fileInfo.target = await getImageFileInfo(blob)
            const dl_token = res.data?.data?.userinfo?.dl_token
            this.fileInfo.target.dl_token = dl_token
            // 更新用户权益
            await this.updateUserInfo()
            this.setAllowDownload(Number(res.data?.data?.i) || 0)
            // }
          } else if (res.data.status === 5001) {
            this.fileInfo.status = 'fail'
            this.$messageDialog({
              showLeft: false,
              showRight: true,
              leftBtnTxt: '取消',
              rightBtnTxt: '开通VIP',
              title: '温馨提示',
              content: `试用次数已用完，请开通VIP后使用！`,
              onClose: () => {},
              onClickLeftBtn: () => {},
              onClickRightBtn: () => {
                this.showPurchaseModal()
              }
            })
          } else {
            this.fileInfo.status = 'fail'
            Message({
              type: 'error',
              message: '处理失败！'
            })
          }
        } else if (handlingMethod === 'upcolor') {
          if (!getToken()) {
            await this.showLoginModal()
            return
          }
          // if (!this.isVip && this.allCert?.image_enhance_init_count <= 0) {
          //   this.$messageDialog({
          //     showLeft: false,
          //     showRight: true,
          //     leftBtnTxt: '取消',
          //     rightBtnTxt: '开通VIP',
          //     title: '温馨提示',
          //     content: `试用次数已用完，请开通VIP后使用！`,
          //     onClose: () => {},
          //     onClickLeftBtn: () => {},
          //     onClickRightBtn: () => {
          //       this.showPurchaseModal()
          //     }
          //   })
          //   return
          // }

          let file1 = file

          // 图片宽高不能超过 4096 * 4096
          if (originInfo?.width > 4096 || originInfo?.height > 4096) {
            let options = {
              resize: 'cover'
            }

            if (originInfo?.width <= originInfo?.height) {
              options.height = 4096
            } else {
              options.width = 4096
            }

            file1 =  await editImage(file, {
              ...options
            })
          }

          // 超过15MB图片要压缩
          if (file1.size >= 15 * 1024 * 1024) {
            // 用户指定压缩大小
            file1 = await outputTheSpecifiedSize(file1, {
              maxSize: 15 * 1024 * 0.95
            })
          }


          let res = await this.colorShifting(file1, colorShiftingOutputFormat)
          if (res.data.status === 0) {
            const imageUrl = res.data?.data?.imageurl


            let blob = await fetch(imageUrl).then(response => response.blob())

            this.fileInfo.target = await getImageFileInfo(blob)
            const dl_token = res.data?.data?.userinfo?.dl_token
            this.fileInfo.target.dl_token = dl_token
            // 更新用户权益
            await this.updateUserInfo()
            this.setAllowDownload(Number(res.data?.data?.i) || 0)
            // }
          } else if (res.data.status === 5001) {
            this.fileInfo.status = 'fail'
            this.$messageDialog({
              showLeft: false,
              showRight: true,
              leftBtnTxt: '取消',
              rightBtnTxt: '开通VIP',
              title: '温馨提示',
              content: `试用次数已用完，请开通VIP后使用！`,
              onClose: () => {},
              onClickLeftBtn: () => {},
              onClickRightBtn: () => {
                this.showPurchaseModal()
              }
            })
          } else {
            this.fileInfo.status = 'fail'
            Message({
              type: 'error',
              message: '处理失败！'
            })
          }
        }


        this.fileInfo.status = 'success'
      } catch (e) {
        this.fileInfo.status = 'fail'
        Message({
          type: 'error',
          message: '处理失败！'
        })
      } finally {
        this.isLoading = false
      }
    }
  }
}
</script>
<style scoped lang="less">
@import url('./index.less');
</style>
